// NOTE: Dependencies: jQuery, defiant

(function($) {
  $.fn.lmSlider = function(options) {
    // check is dom element is defined
    if (!this.length) {
      return false;
    }

    // Default settings are set here.
    var settings = $.extend({
      $body: $('body'),
      $slider: $('[data-slick]'),
      $html: $('html')
    }, options);

    // These are all the methods available for the plugin.
    var methods = {};

    methods.setCurrentSettings = function($context) {
      var currentSettings = $context.data();

      if (!$.isEmptyObject(currentSettings)) {
        $context.data($.extend({}, settings, currentSettings));
      } else {
        $context.data(settings);
      }

      // Initialize item.
      $context.data('initialized', true);
      settings.$form = $context.closest('form');
      settings.$loader = settings.$form.parent();
      settings.$predictiveInput = settings.$form.find('input');
    };

    // Toggle Active Classes
    methods.toggle = function($context) {
      $context.toggleClass(settings.activeClass);
    };

    // On load function.
    methods.initContext = function($context) {
      methods.setCurrentSettings($context);

      if ($context.length) {
        $context.each(function() {
          var $slider = $(this);

          if ($slider.hasClass('slider')) {
            $slider.imagesLoaded(function() {
              $slider.slick({
                mobileFirst: true
              });
            });
          } else if ($slider.hasClass('slider') && (!settings.$html.hasClass('is-mobile') && !settings.$html.hasClass('is-tablet')) && settings.$html.hasClass('no-touchevents')) {
            $slider.imagesLoaded(function() {
              $slider.slick({
                mobileFirst: true
              });
            });
          }
          // Support for
          else if ($slider.hasClass('slider') && settings.$html.hasClass('is-desktop') && settings.$html.hasClass('touchevents')) {
            $slider.imagesLoaded(function() {
              $slider.slick({
                mobileFirst: true
              });
            });
          }
        });
      }
    };

    // Filter each function.
    methods.filterEach = function() {
      return !$(this).data('initialized');
    };

    // Methods to run inside loop.
    return this.filter(methods.filterEach).each(function() {
      // NOTE: Method you'd like initialized on a per context basis.
      methods.initContext($(this));
    });

  };

  if ($('[data-slick]').length) {
    $('[data-slick]').lmSlider();
  }

}(jQuery));
